const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnRefresh(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.828,
    height: 12.828,
    viewBox: "0 0 12.828 12.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 222",
    transform: "translate(1.414 1.414)",
    style: {
      fill: "none",
      stroke: "#c8cace",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "m0 0 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 223",
    transform: "translate(1.414 1.414)",
    style: {
      fill: "none",
      stroke: "#c8cace",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M10 0 0 10"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRefresh);
export default __webpack_public_path__ + "static/media/btn-refresh.67177b10da1d4b20a3729aa8ed1f5a84.svg";
export { ForwardRef as ReactComponent };